module.exports = __webpack_public_path__ + "img/img_80.6d190a66.png";